<template>
    <span
        class="lang-btn"
        :style="{ border: `0.5vh solid ${color}`, color }"
        @click="changeLanguage"
    >
        {{ selectedLanguageLabel }}
    </span>
</template>

<script>
    const LANGUAGE_LABELS = {
        en: {
            label: 'ΕΛ',
            nextLang: 'el'
        },
        el: {
            label: 'EN',
            nextLang: 'en'
        }
    }
    export default {
        props: {
            color: {
                type: String,
                default: '#fff'
            }
        },
        computed: {
            language() {
                return this.$store.getters.getLanguage
            },
            selectedLanguageLabel() {
                return LANGUAGE_LABELS[this.language].label
            },
            selectedNextLanguage() {
                return LANGUAGE_LABELS[this.language].nextLang
            }
        },
        methods: {
            changeLanguage() {
                this.$router.push({
                    path: `/routesInfos/${this.$route.params.screenId}`,
                    query: { lang: this.selectedNextLanguage }
                })
                this.$i18n.locale = this.selectedNextLanguage
                this.$store.dispatch('toggleLanguage', this.selectedNextLanguage)
            }
        }
    }
</script>

<style scoped>
.lang-btn {
  display: grid;
  place-content: center;
  border-radius: 25%;
  font-weight: 600;
  font-size: 2.5vh;
  padding: 0.5rem;
  position: absolute;
  right: 5%;
  transform: translateY(-150%);
  width: 6vh;
  height: 6vh;
}

@media screen and (min-width: 1264px) {
  .lang-btn {
    position: relative;
    right: unset;
    transform: unset;
  }

  .lang-btn:hover {
    background-color: #dedede;
    color: #ee7d11;
    cursor: pointer;
  }
}
</style>
